import React from 'react'
import { useLocation } from 'react-router-dom'
import KlimtText from '@eversports/klimt-primitives/legacy/Text'

import useCheckoutContext from '../../data/useCheckoutContext'
import getPhoenixUrlParams from '../../lib/get-phoenix-url-params'
import { Intl, Localized } from '../../localization/react'

interface Props {
  isOrderConfirmed: boolean
  hasSelfCheckIn: boolean
  hasBooking: boolean
  isBookingRequest: boolean
  venueName: string
}

const ConfirmationSubHeading: React.FC<React.PropsWithChildren<Props>> = ({
  isOrderConfirmed,
  hasSelfCheckIn,
  hasBooking,
  isBookingRequest,
  venueName,
}): React.ReactElement<Intl> => {
  const location = useLocation()
  const { isVenueBrandingEnabled } = useCheckoutContext()
  const { hideEversportsBranding } = getPhoenixUrlParams(location.search)
  if (isBookingRequest) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, marginBottom: 32 }}>
        <KlimtText variant="large" sx={{ textAlign: 'center' }}>
          <Localized id="private-session-booking-request-subheading-1" />
        </KlimtText>
        <KlimtText sx={{ fontWeight: '600', textAlign: 'center' }}>
          <Localized id="private-session-booking-request-subheading-2" params={{ venueName }} />
        </KlimtText>
      </div>
    )
  }

  // there wasn't a booking of an activity but instead a purchase of a product or payment of an invoice
  if (!hasBooking) {
    return (
      <KlimtText textAlign="center" fontWeight="bold" marginBottom={4}>
        <Localized id="purchase-confirmation-sub-heading" />
      </KlimtText>
    )
  }

  // booking requested, but it hasn't yet been confirmed by the venue
  if (!isOrderConfirmed) {
    return (
      <KlimtText textAlign="center" fontWeight="bold" marginBottom={4}>
        <Localized id="booking-confirmation-sub-heading-no-confirmed" />
      </KlimtText>
    )
  }

  // booking has already been confirmed by the venue and it hasn't self-checkin
  if (!hasSelfCheckIn) {
    return (
      <KlimtText textAlign="center" fontWeight="bold" marginBottom={4}>
        <Localized id="booking-confirmation-sub-heading-without-self-check-in" />
      </KlimtText>
    )
  }

  // WITHOUT Eversports branding - booking has already been confirmed by the venue and it has self-checkin
  if (isVenueBrandingEnabled || hideEversportsBranding) {
    return (
      <KlimtText textAlign="center" fontWeight="bold" marginBottom={4}>
        <Localized id="booking-confirmation-sub-heading-unbranded" />
      </KlimtText>
    )
  }

  // WITH Eversports branding - booking has already been confirmed by the venue and it has self-checkin
  return (
    <KlimtText textAlign="center" fontWeight="bold" marginBottom={4}>
      <Localized id="booking-confirmation-sub-heading" />
    </KlimtText>
  )
}

export default ConfirmationSubHeading
